// https://stackoverflow.com/questions/53558916/babel-7-referenceerror-regeneratorruntime-is-not-defined
import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { InteractiveProducts } from "./react/components/InteractiveProducts.jsx";

export const INTERACTIVE_PRODUCTS_BREAKPOINT = 992;

/**
 *
 * Metoda, která se stará o inicializaci produktů nad určitým kontejnerem, který vyplní
 * určitou sadou dat.
 *
 * @param {Object} data
 */
export const initInteractiveProducts = (data) => {
	if (!data) {
		return;
	}

	const { productsByPages } = data;

	if (!productsByPages) {
		return;
	}

	if (Object.keys(productsByPages).length === 0) {
		return;
	}

	data.translations = data.translations ?? {};


	const interactiveRoot = document.createElement("div");

	document.body.appendChild(interactiveRoot);

	const productsReactRoot = createRoot(interactiveRoot);

	productsReactRoot.render(<InteractiveProducts data={data} />);
};
